module.exports = __webpack_public_path__ + "img/Title_Security_JP.e501ad48.png";